import { createSlice } from "@reduxjs/toolkit";

interface MsgState {
  value: string;
}

const initialState = {
  value: "",
} as MsgState;

export const mgsSlice = createSlice({
  name: "msg",

  initialState,
  reducers: {
    setShowAlert: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { setShowAlert } = mgsSlice.actions;
export default mgsSlice.reducer;
